import * as React from 'react';
import { Result as SharedResult } from '~shared/components/Validation/Result';
import { ValidationMessageHeading } from './ValidationMessageHeading';
import { ValidationMessageReason } from './ValidationMessageReason';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Success/Error message with the icon, a `heading` & an _optional_ `message`.
 */
export var Result = function Result(_ref) {
  var heading = _ref.heading,
      message = _ref.message,
      type = _ref.type;
  return /*#__PURE__*/_jsxs(SharedResult, {
    type: type,
    children: [/*#__PURE__*/_jsx(ValidationMessageHeading, {
      textAlign: "center",
      children: heading
    }), message && /*#__PURE__*/_jsx(ValidationMessageReason, {
      textAlign: "center",
      children: message
    })]
  });
};